<script setup>
import BaseIcon from '@/components/shared/ui/BaseIcon.vue'
import { useNotify } from '@/utils/notify'
import { useI18n } from 'vue-i18n'
const { input } = defineProps({
  input: {
    type: String,
    required: true
  }
})
const { t } = useI18n()
const copyToClipboard = async () => {
  const notify = useNotify()
  try {
    await navigator.clipboard.writeText(input)
    notify.success({ title: t('common.status.copiedToClipboard') })
  } catch {
    notify.error({ title: t('common.status.copyFailed') })
  }
}
</script>

<template>
  <button
    type="button"
    class="flex items-center gap-2 w-fit cursor-pointer hover:text-gray-700"
    @click="copyToClipboard"
  >
    <span class="truncate">
      <slot></slot>
    </span>
    <BaseIcon class="fa-xl" icon="copy" />
  </button>
</template>
